module.exports = __webpack_public_path__ + "img/kirche.34b1eccc.png";